import { Box } from '@material-ui/core'
import styled from 'styled-components'

export const StyledTabsWrapper = styled.div`
  position: relative;

  .MuiBox-root {
    padding: 0;
  }

  .MuiAppBar-colorPrimary {
    background-color: transparent;
    color: #000;
    box-shadow: none;
  }

  .MuiTabs-flexContainer {
    min-height: 72px;
  }

  .MuiTab-root {
    padding: 0px;
  }

  .MuiTab-wrapper {
    margin-top: 26px;
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-end;
    align-items: center;
    text-transform: capitalize;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    svg {
      margin-left: 5px;
    }
  }

  .inactive .MuiTab-wrapper {
    color: #92969a;
  }

  .MuiTabs-indicator {
    height: 4px;
    ${({ shouldNotTransition }) => (shouldNotTransition ? 'transition: none;' : '')}
  }

  .PrivateTabIndicator-colorSecondary-7 {
    background-color: #044f98;
    height: 4px;
  }

  .MuiTab-fullWidth::before {
    content: '';
    position: absolute;
    bottom: -2px;
    height: 6px;
    background: #d4e5f7;
    width: 100%;
  }

  .inactive.MuiTab-fullWidth::before {
    background-color: #f6f6f6;
  }

  .MuiTab-labelIcon .MuiTab-wrapper > *:first-child {
    margin-bottom: 0;
  }

  .MuiChip-root {
    background: #f6f6f6;
    border-radius: 2px;
  }

  .MuiChip-label {
    overflow: hidden;
    white-space: nowrap;
    padding-left: 12px;
    padding-right: 12px;
    text-overflow: ellipsis;
    background: #f6f6f6;
    border-radius: 2px;
  }

  .MuiTabs-flexContainer {
    gap: 8px;
  }
`

export const StyledSplitTabsWrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
  bottom: 0;
  width: 100%;
  height: 6px;
  gap: 5px;
`

export const StyledSplitTab = styled(Box)`
  flex: 1;
  height: 100%;
  background-color: ${({ checked }) => (checked ? '#044f98' : '#d4e5f7')};
  border-radius: 2;
`
